import React from 'react'
import Loading from '@Components/Loading/Loading'
import Redux from 'redux'
import { connect } from 'react-redux'
import Header from '../Header/Header'
import Sidebar from './Sidebar'
import './ClientLayout.scss'

interface IClientLayout {
    children: React.ReactNode

    // redux
    isLoading?: boolean
}

const ClientLayout = ({ children, isLoading }: IClientLayout) => {
    return (
        <div className="client-layout">
            <Header />
            <div className="client-wrapper">
                <Sidebar />
                <div className="client-content">
                    <div className="client-layout-loading-container">
                        {/* &nbsp;{' '} */}
                        <Loading
                            isLoading={isLoading}
                            className="client-layout-loading"
                        />{' '}
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

// store section
const mapStateToProps = (state: any) => {
    const isLoading = state?.shared?.loadings?.clientLoading
    return {
        isLoading,
    }
}

export default connect(mapStateToProps, null)(ClientLayout)
